import { render, staticRenderFns } from "./BankStatementUpload.vue?vue&type=template&id=0e5a2a56&"
import script from "./BankStatementUpload.vue?vue&type=script&lang=js&"
export * from "./BankStatementUpload.vue?vue&type=script&lang=js&"
import style0 from "./BankStatementUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports